import React from "react";
import Phase from '../components/Phase';
import Quote from '../components/Quote';
export default ({ isActive }) => {
  const message = `In Phase 3, the patient pool grows even larger as the drug candidate is tested against placebos or standard treatment to ensure it’s both safe and effective. Authorities such as the US Food and Drug Administration (FDA) then examine the results to determine whether or not to approve.`;
  const quote = {
    author: '',
    position: 'Oncologist and Global Head of Translational Clinical Oncology at Novartis',
    img: null,
    quote: [message]
  }
  const phaseOne = {
    phase: 3,
    title: 'Deepening Our Understanding',
    parts: '300-3,000',
    studyLength: 'Typically 1 to 4 years',
    success: .30
  }

  const utm = 'https://www.novartis.com/clinicaltrials?utm_source=cnn&utm_medium=infographic&utm_campaign=2020-11-clinical-trials-cnn&utm_content=phase-3-link';
  
  return (
    <div className="component fifth-component">
      <div>
        <Quote quote={quote} isActive={isActive} showQuotemark={ false} />
        <Phase {...phaseOne} position="left" utm={utm} />
      </div>
    </div>
  );
};
